import createComponentPreset from "../../../../../fabrics/createComponentPreset";
import { createDisplayNameForMediaElement } from "../../../utils/getDisplayName";
import { createTestIdForMediaElement } from "../../../utils/getTestId";
import Addon from "../Addon/MediaAddon";

import classes from "./MediaTopRightAddon.styl";

const TOP_RIGHT_ADDON_DISPLAY_NAME = "TopRightAddon";
const TOP_RIGHT_ADDON_TEST_ID = createTestIdForMediaElement(
    TOP_RIGHT_ADDON_DISPLAY_NAME,
);

/**
 * @deprecated
 * Используйте вместо этого компонента UniBoxAdditional / UniBoxMain
 */
export const TopRightAddon = createComponentPreset(
    TOP_RIGHT_ADDON_DISPLAY_NAME,
    Addon,
    {
        className: classes.addon,
        "data-tsid": TOP_RIGHT_ADDON_TEST_ID,
    },
);

TopRightAddon.displayName = createDisplayNameForMediaElement(
    TOP_RIGHT_ADDON_DISPLAY_NAME,
);

export default TopRightAddon;
